"use client"

import type { CSSProperties } from "react"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

/*
 * A toast is a small sheet: paper, hairline, shadow.lift. Tone is a rule, not a
 * fill — a 3px left rule, do for success, caution for error and warning, print
 * for info (the unlayered rules in blueprints.css, because sonner's own
 * stylesheet is unlayered and outranks every utility class). Sonner paints
 * from its variables, so those are pointed at the tokens here; its greens and
 * reds (`richColors`) never mount.
 */
const sheet = {
  "--normal-bg": "var(--color-bg-primary)",
  "--normal-border": "var(--color-border-secondary)",
  "--normal-text": "var(--color-text-primary)",
  "--border-radius": "var(--radius-xl)",
  fontFamily: "var(--font-body)",
} as CSSProperties

const Toaster = ({ style, ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      style={{ ...sheet, ...style }}
      toastOptions={{
        classNames: {
          toast: "group toast",
          description: "group-[.toast]:text-tertiary",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
